export default __webpack_public_path__ + "static/media/CEO.139909fe.jpg";